import _ from 'lodash';

const isEqualWith = (value, other, customizer) => _.isEqualWith(value, other, customizer);

export { isEqualWith };
